import React, { useEffect, useState } from 'react';
import leftArrowIcon from '../../../public/assets/images/leftArrowIcon.png';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { expenseWisedetails } from '../../redux/slice/expenseApproval';
import Preview from '../../components/preview';

const OtherExpenseApproval = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const { details } = useSelector((state) => state.expenseApproval);
  const [previewUrl, setPreviewUrl] = useState(null);

  useEffect(() => {
    if (location.state) {
      dispatch(expenseWisedetails(location?.state?.expenseId));
    }
  }, [location.state]);

  return (
    <div className="lg:mt-16 p-4">
      <Preview
        show={previewUrl}
        url={previewUrl}
        onClose={() => {
          setPreviewUrl(null);
        }}
      />

      <div className="flex justify-center items-center w-full h-10 relative p-4 lg:p-2 mt-20 mb-2 lg:mt-0 lg:mb-0 lg:flex lg:justify-start lg:items-center smAndMd:mt-6 smAndMd:mb-4 px-3 py-5">
        <Link to={-1} className="absolute  left-4 lg:left-0">
          <img
            src={leftArrowIcon}
            alt="leftIcon"
            height={'10px'}
            width={'10px'}
          />
        </Link>
        <p className="text-lg font-semibold text-center lg:ml-4 text-primary lg:text-baselg lg:font-semibold ">
          Other Expense
        </p>
      </div>
      <div className="w-full h-[0.5px] bg-line-color hidden lg:block"></div>

      <div className="hidden lg:block">
        <div className="flex justify-between items-center mt-4">
          <div className="text-[#514D4C] font-semibold text-lg">Approval</div>
          {/* <div className="flex gap-2">
          <div className="flex justify-center items-center cursor-pointer text-[#F3903F] font-medium">
            Pending
          </div>
          <div></div>
        </div> */}
        </div>

        <div className="grid grid-cols-5 bg-[#EEEEEE] item-center flex-wrap rounded-t-md p-4 font-semibold text-xs text-center text-gray-700 smAndMd:hidden mt-5">
          <div className="col-span-1 text-[#514D4C]">Activity Date</div>
          <div className="col-span-1 border-l border-gray-400 text-[#514D4C]">
            Other Expense
          </div>
          <div className="col-span-1 border-l border-gray-400 text-[#514D4C]">
            Actual Value
          </div>
          <div className="col-span-1 border-l border-gray-400 text-[#514D4C]">
            Uploaded File
          </div>
          <div className="col-span-1 border-l border-gray-400 text-[#514D4C]">
            Description
          </div>
        </div>

        {details
          ?.filter(
            (expenseItem) => expenseItem?.otherExpenseTypeDto?.length > 0
          )
          .map((item) =>
            item?.otherExpenseTypeDto?.map((item) => {
              return (
                <>
                  <div className="grid grid-cols-5">
                    <div className="flex justify-center items-center pt-2">
                      {item?.dateOfActivity?.split('-').reverse().join('-')}
                    </div>
                    <div className="flex justify-center items-center pt-2">
                      {item?.expenseName}
                    </div>
                    <div className="flex justify-center items-center pt-2">
                      {item?.enteredValue}
                    </div>
                    <div
                      className="flex justify-center items-center pt-2 underline text-[#A04D95] cursor-pointer"
                      onClick={() => {
                        setPreviewUrl(item?.fileUploaded);
                      }}
                    >
                      View
                    </div>
                    <div className="flex justify-center items-center pt-2">
                      {item?.description}
                    </div>
                  </div>{' '}
                </>
              );
            })
          )}

        <div className="grid grid-cols-3 bg-[#EEEEEE] item-center flex-wrap p-4 font-semibold text-xs  text-gray-700 smAndMd:hidden mt-5">
          <div className="col-span-1 text-[#514D4C] flex gap-4">
            <span>Entered Total</span>
            <span>
              <span>₹</span>{' '}
              <span>
                {details?.reduce((sum, expenseItem) => {
                  const innerTotal =
                    expenseItem?.otherExpenseTypeDto?.reduce(
                      (acc, obj) => acc + (obj?.enteredValue || 0),
                      0
                    ) || 0;

                  return sum + innerTotal;
                }, 0)}
              </span>
            </span>
          </div>
          <div className="col-span-1  text-[#514D4C] flex gap-4">
            <span>Updated Value</span> <span>0.00</span>
          </div>
          {/* <div className="col-span-1  text-[#514D4C] flex gap-4">
          <span>Remarks</span> <input type="text" height={150} width={150} />
        </div> */}
        </div>

        {/* desktop deisgn */}
        <div className="flex justify-end items-center p-4">
          <div
            className="border-2 rounded-full border-[#A04D95] cursor-pointer w-[164px] h-[50px] flex justify-center items-center"
            onClick={() => {
              navigate(-1);
            }}
          >
            <button className="font-bold text-[#A04D95] text-[18px]">
              Back
            </button>
          </div>
        </div>
      </div>

      {/* Mobile design */}

      <div className="sm:max-lg:block lg:hidden p-4">
        <div className="text-[#514D4C] font-semibold text-lg py-2">
          Approval
        </div>
        <div className="w-full h-[0.5px] bg-line-color"></div>

        {details
          ?.filter(
            (expenseItem) => expenseItem?.otherExpenseTypeDto?.length > 0
          )
          .map((item) =>
            item?.otherExpenseTypeDto?.map((item) => {
              return (
                <>
                  <div className="flex flex-col justify-between gap-2 mt-2 border-b pb-2">
                    <div className="flex justify-between">
                      <div className="text-[#949494] font-medium text-xs">
                        {item?.expenseName}
                      </div>
                      <div className="text-[#949494] font-medium text-xs">
                        {item?.dateOfActivity?.split('-').reverse().join('-')}
                      </div>
                    </div>
                    <div className="flex justify-between">
                      <div className="text-[#514D4C] font-medium text-sm">
                        {item?.description}
                      </div>
                      <div className="text-[#514D4C] font-medium text-sm">
                        <span>₹</span> {item?.enteredValue}
                      </div>
                    </div>
                    <div className="flex justify-between">
                      <div className="text-[#514D4C] font-medium text-sm">
                        Updated File
                      </div>
                      <div
                        className="underline text-[#A04D95] cursor-pointer"
                        onClick={() => {
                          setPreviewUrl(item?.fileUploaded);
                        }}
                      >
                        View
                      </div>
                    </div>
                  </div>
                </>
              );
            })
          )}

        <div className="grid grid-cols-4 gap-2 bg-[#EEEEEE] h-20 p-4 mt-4">
          <div className="text-[#514D4C] font-medium">Entered Total</div>
          <div>
            <span>₹</span>
            {details?.reduce((sum, expenseItem) => {
              const innerTotal =
                expenseItem?.otherExpenseTypeDto?.reduce(
                  (acc, obj) => acc + (obj?.enteredValue || 0),
                  0
                ) || 0;

              return sum + innerTotal;
            }, 0)}
          </div>
          <div className="text-[#514D4C] font-medium">Updated Value</div>
          <div>0.00</div>
        </div>
      </div>
    </div>
  );
};

export default OtherExpenseApproval;
